import { joinChannel } from './ws-actions';

export const emitBlogOpened = () => joinChannel('blog');

export const POST_PUBLISHED = 'post/PUBLISHED';
